import { createSelector } from "reselect";
import { AppState } from "../rootReducer";

// source list 

const getProfileData = (state: AppState) => state.user.profile;
const getRoleClaims = (state: AppState) => state.user.roles;
const getAccessToken = (state: AppState) => state.user.accessToken;
const getTokenClaims = (state: AppState) => state.user.tokenClaims;

export const getProfileDataSelector = createSelector(getProfileData, (profile) => profile);
export const getRoleClaimsSelector = createSelector(getRoleClaims, (roles) => roles);
export const getAccessTokenSelector = createSelector(getAccessToken,(accessToken) => accessToken);
export const getTokenClaimsSelector = createSelector(getTokenClaims, (tokenClaims) => tokenClaims);